<template>
  <TransitionRoot as="template" :show="sideBarIsOpen">
    <Dialog
      as="div"
      class="fixed inset-0 flex z-40 lg:hidden"
      @close="$emit('sideBarToggled', false)"
    >
      <TransitionChild
        as="template"
        enter="transition-opacity ease-linear duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="transition-opacity ease-linear duration-300"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-gray-600 bg-opacity-75" />
      </TransitionChild>
      <TransitionChild
        as="template"
        enter="transition ease-in-out duration-300 transform"
        enter-from="-translate-x-full"
        enter-to="translate-x-0"
        leave="transition ease-in-out duration-300 transform"
        leave-from="translate-x-0"
        leave-to="-translate-x-full"
      >
        <div
          class="
            relative
            flex-1 flex flex-col
            max-w-xs
            w-full
            pt-5
            pb-4
            bg-white
          "
        >
          <TransitionChild
            as="template"
            enter="ease-in-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in-out duration-300"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <div class="absolute top-0 right-0 -mr-12 pt-2">
              <button
                type="button"
                class="
                  ml-1
                  flex
                  items-center
                  justify-center
                  h-10
                  w-10
                  rounded-full
                  focus:outline-none
                  focus:ring-2
                  focus:ring-inset
                  focus:ring-white
                "
                @click="$emit('sideBarToggled', false)"
              >
                <span class="sr-only">Close sidebar</span>
                <XIcon class="h-6 w-6 text-white" aria-hidden="true" />
              </button>
            </div>
          </TransitionChild>
          <div class="flex-shrink-0 px-4 text-lg font-black leading-tight">
            <p class="text-gray-700">Análisis</p>
            <p class="text-light-blue-500">Ambiental</p>
          </div>
          <div class="mt-5 flex-1 h-0 overflow-y-auto">
            <nav class="px-2">
              <div class="space-y-1">
                <div v-for="(menuItem, index) in menu" :key="menuItem.text">
                  <button
                    v-if="
                      'children' in menuItem && menuItem.children.length > 0
                    "
                    @click="
                      menuCollapsedToggles[index] = !menuCollapsedToggles[index]
                    "
                    class="
                      w-full
                      group
                      flex
                      items-center
                      px-2
                      py-2
                      text-base
                      leading-5
                      font-medium
                      rounded-md
                      hover:text-gray-900
                      focus:outline-none
                      transition
                      ease-in-out
                      duration-150
                      hover:bg-gray-50
                      focus:bg-gray-50
                      text-gray-600
                    "
                  >
                    <component
                      class="
                        text-gray-400
                        mr-3
                        h-6
                        w-6
                        group-hover:text-gray-500
                        group-focus:text-gray-600
                        transition
                        ease-in-out
                        duration-150
                      "
                      :is="menuItem.iconComponent"
                    />
                    {{ menuItem.text }}
                  </button>

                  <Link
                    v-else
                    @click="$emit('sideBarToggled')"
                    :href="route(menuItem.route)"
                    :class="{
                      'text-light-blue-600 bg-light-blue-50': route().current(
                        menuItem.route
                      ),
                      'hover:bg-light-blue-50 hover:text-light-blue-600 text-gray-700':
                        !route().current(menuItem.route),
                    }"
                    class="
                      group
                      flex
                      items-center
                      px-2
                      py-2
                      text-base
                      leading-5
                      font-medium
                      rounded-md
                      hover:text-gray-900
                      focus:outline-none
                      transition
                      ease-in-out
                      duration-150
                    "
                  >
                    <component
                      class="
                        mr-3
                        h-6
                        w-6
                        group-hover:text-light-blue-400
                        transition
                        ease-in-out
                        duration-150
                      "
                      :class="
                        route().current(menuItem.route)
                          ? 'text-light-blue-400'
                          : 'text-gray-400'
                      "
                      :is="menuItem.iconComponent"
                    />
                    {{ menuItem.text }}
                  </Link>

                  <div
                    class="mt-1 space-y-1"
                    v-if="
                      'children' in menuItem && menuItem.children.length > 0
                    "
                    v-show="menuCollapsedToggles[index]"
                  >
                    <Link
                      v-for="(submenuItem, subindex) in menuItem.children"
                      :key="subindex"
                      :href="route(submenuItem.route)"
                      class="
                        group
                        w-full
                        flex
                        items-center
                        pl-10
                        pr-2
                        py-2
                        text-sm
                        leading-5
                        font-medium
                        text-gray-600
                        rounded-md
                        hover:text-gray-900 hover:bg-gray-50
                        focus:outline-none focus:text-gray-900 focus:bg-gray-50
                        transition
                        ease-in-out
                        duration-150
                      "
                      >{{ submenuItem.text }}</Link
                    >
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </TransitionChild>
      <div class="flex-shrink-0 w-14" aria-hidden="true">
        <!-- Dummy element to force sidebar to shrink to fit close icon -->
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  HomeIcon,
  CalendarIcon,
  UsersIcon,
  UserGroupIcon,
  ShieldCheckIcon,
  ViewGridIcon,
  BeakerIcon,
  DocumentTextIcon,
  UserIcon,
  DesktopComputerIcon,
  XIcon,
} from "@heroicons/vue/outline";

import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay,
} from "@headlessui/vue";

export default {
  emits: ["sideBarToggled"],

  components: {
    HomeIcon,
    CalendarIcon,
    UsersIcon,
    UserGroupIcon,
    ShieldCheckIcon,
    ViewGridIcon,
    BeakerIcon,
    DocumentTextIcon,
    UserIcon,
    DesktopComputerIcon,
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon,
  },
  props: {
    sideBarIsOpen: {
      type: Boolean,
      required: true,
    },
    menu: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      profileToggle: false,
      menuCollapsedToggles: {},
    };
  },

  mounted() {
    this.menu.forEach((element, index) => {
      if ("children" in element && element.children.length > 0) {
        this.$set(this.menuCollapsedToggles, index, false);
      }
    });
  },
};
</script>